import { createActions, createAction } from 'redux-actions';
import moment from 'moment';
import qs from 'qs';
import { isEqual } from 'lodash';
import {
  membersContainCrews,
  reorderResultsAndPrioritizeCrews,
  getInstallSuggestions,
} from '../../utils/schedulingUtils';
import { request } from '../../services';
import { userUpdatePreferences } from 'actionCreators';

const {
  scheduleSuccess,
  scheduleFailure,
  scheduleRequest,
  suggestionRequest,
  suggestionSuccess,
} = createActions({
  SCHEDULE_SUCCESS: json => json,
}, 'SCHEDULE_FAILURE', 'SCHEDULE_REQUEST', 'SUGGESTION_REQUEST', 'SUGGESTION_SUCCESS');

export const loadSchedule = (
  start,
  filters,
  calendarRequest,
  calendarArgs = {},
  addtlArgs = { emptyMembers: false },
) => (dispatch) => {
  const startDate = moment(start).format('YYYY-MM-DD');
  let requestString = `schedule?start_date=${startDate}&calendar_request=${calendarRequest ? 1 : 0}`;
  if (calendarRequest && (addtlArgs.emptyMembers || false)) {
    return dispatch(scheduleSuccess({ members: [] }));
  }
  if (calendarRequest) {
    const { days, isScheduleBoard } = calendarArgs;
    const daysToAdd = !isScheduleBoard ? days + 30 : days;
    const endDate = moment(start).add(daysToAdd, 'days').format('YYYY-MM-DD');
    requestString += `&end_date=${endDate}`;
    dispatch(scheduleRequest({ startDate, endDate }));
  } else dispatch(suggestionRequest({ startDate }));
  return request(`${requestString}&${qs.stringify(filters)}`)
    .then(({ json }) => {
      let members = json;
      if (!calendarRequest && membersContainCrews(members)) {
        const { phase, relatedPhases } = addtlArgs;
        getInstallSuggestions(members, phase, startDate, relatedPhases)
          .then(res => dispatch(suggestionSuccess(res)));
      } else if (!calendarArgs.isScheduleBoard) {
        const { defaultCalStart, role, username, pendingAppointment,
                applySmartScheduling = false, isCcs = false, phaseSource = '' } = addtlArgs;
        if (role === 'iqm') members = json.filter(m => m.assignee.name === username);
        else if (!!pendingAppointment && (pendingAppointment.kind === 'delivery' ||
                  pendingAppointment.kind === 'delivery_hold' ||
                  pendingAppointment.kind === 'deliver_stack_cali_bamboo')) {
          members = json.filter(m => m.assignee.can_deliver);
        }
        if (applySmartScheduling &&
            members.length &&
            membersContainCrews(members) &&
            pendingAppointment &&
            phaseSource !== 'IFI') {
          dispatch(scheduleSuccess({
            members: reorderResultsAndPrioritizeCrews(
              members, pendingAppointment, defaultCalStart, isCcs,
            ),
          }));
        } else dispatch(scheduleSuccess({ members }));
      } else dispatch(scheduleSuccess({ members }));
    }).catch(error => dispatch(scheduleFailure(error)));
};

export const loadSuggestions = (phaseId, phaseType, start, isCcs = false) => (dispatch) => {
  const startDate = moment(start).format('YYYY-MM-DD');
  const isCcsString = isCcs ? 'y' : 'n';
  dispatch(suggestionRequest({ phaseId, phaseType, startDate }));
  return request(`suggestion?phase_id=${phaseId}&phase_type=${phaseType}&start_date=${startDate}&is_ccs=${isCcsString}`)
    .then(({ json }) => dispatch(suggestionSuccess(json)));
};

const updateScheduleFiltersRequest = createAction('SCHEDULE_UPDATE_FILTERS');

export const updateScheduleFilters = filters => (dispatch, getState) => {
  const promises = [];
  if (!isEqual(filters, getState().schedule.filters)) {
    promises.push(dispatch(userUpdatePreferences({ saved_schedule_filters: filters })));
  }
  promises.push(dispatch(updateScheduleFiltersRequest(filters)));
  return Promise.all(promises);
};



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/schedule.js